'use client';

import { captureReferringSite } from '@/tools/views';
import { useEffect } from 'react';

export const HandlerReferringSite = () => {
  useEffect(() => {
    captureReferringSite();
  }, []);

  return null;
};
